import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { SetPlaceSourceModalData } from './set.place.source.modal.provider';

@Component({
  templateUrl: './set.place.source.modal.component.html',
  styleUrls: ['./set.place.source.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SetPlaceSourceModalComponent extends BaseComponent {
  public loading = false;
  public placeSource = 'facebook';
  // public isAreaBusiness = false;
  public businessType = 'normal';
  public isUseIgDefaultCustomPlaceCategories = true;
  public showPlaceImageCount = 5;
  public nearbyPlacesDefaultRange = 2;
  public initial = 'facebook';
  public googleKey = '';
  public blockCategories = '';
  public blockKeywords = [];
  public account: SetPlaceSourceModalData;
  public formGroup: FormGroup;
  @ViewChild('success') success: SuccessWrapComponent;

  constructor(
    private fb: FormBuilder,
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private dialogRef: MatDialogRef<SetPlaceSourceModalComponent>,
    data: SetPlaceSourceModalData
  ) {
    super();
    this.account = Object.assign({}, data);
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      googleKey: [null, null],
      blockCategories: [null, null],
    });

    this.loading = true;
    this.accountApiService.getPlaceSource(this.account.account.userName)
      .subscribe((source) => {
        if (source && source.place) {
          this.placeSource = source.place;
          this.initial = this.placeSource;
          this.googleKey = source.googleKey;
          this.businessType = source.businessType;
          this.isUseIgDefaultCustomPlaceCategories = source.isUseIgDefaultCustomPlaceCategories;
          this.blockKeywords = source.blockPlaceKeywords ? source.blockPlaceKeywords.split(', ') : [];

          if (this.placeSource && this.placeSource === 'google') {
            this.accountApiService.getGooglePlaceBlockedCategories(this.account.account.userName).subscribe((data) => {
              this.blockCategories = (data && data.value && data.value) || '';
            });
          }

          this.showPlaceImageCount = source.placeImagesShownCount;
          this.nearbyPlacesDefaultRange = source.nearbyPlacesDefaultRange;
        }
        this.loading = false;
      });
  }

  public setPlaceSource() {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        if (this.placeSource === 'facebook') {
          this.accountApiService
            .setPlaceSource(this.account.account.userName, this.placeSource, this.googleKey)
            .subscribe((data) => {
              this.alertify.successfully('Set place source');
              setTimeout(() => {
                this.close();
              }, 1000);
            });
          event.complete();
        } else {
          event.complete();
        }
      },
      cancel: () => {
        this.placeSource = this.initial;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: `Are you sure you want to set the place source for this account, this will switch client places totally?`,
      confirmModalConfirmButtonText: 'Yes',
      confirmModalCancelButtonText: 'No',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        {provide: ConfirmModalActions, useValue: actions},
        {provide: ConfirmModalData, useValue: data},
      ],
    });
  }

  public setBusinessType($event: ButtonTriggerEvent) {
    this.accountApiService.setBusinessType(this.account.account._id, this.businessType).subscribe((data) => {
      this.alertify.successfully('Set business type');
      $event.complete();
    });
  }

  public savePlaceImagesCount(event: ButtonTriggerEvent) {
    this.accountApiService
      .setPlaceImagesShown(this.account.account._id, this.showPlaceImageCount)
      .finally(event.complete)
      .subscribe((data) => {
        this.alertify.successfully('Set place images count to be shown');
        // this.close();
      });
  }

  public saveNearbyPlacesDefaultRange(event: ButtonTriggerEvent) {
    this.accountApiService
      .setNearbyPlacesDefaultRange(this.account.account._id, this.nearbyPlacesDefaultRange)
      .finally(event.complete)
      .subscribe((data) => {
        this.alertify.successfully('Set nearby places default range');
      });
  }


  public saveGoogleKey(event: ButtonTriggerEvent) {
    if (!this.googleKey) {
      this.alertify.error('Please enter the Google Appkey!');
      return;
    }
    this.accountApiService
      .setPlaceSource(this.account.account.userName, this.placeSource, this.googleKey)
      .subscribe((data) => {
        this.alertify.successfully('Set place source');
        // this.close();
      });
    event.complete();
  }

  public block(event: ButtonTriggerEvent) {
    this.accountApiService
      .setGooglePlaceBlockedCategories(this.account.account.userName, this.blockCategories)
      .subscribe((data) => {
        this.alertify.successfully('Set blocked categories for Google places');
        event.complete();
      });
  }

  public blockPlaceKeywords(event: ButtonTriggerEvent) {
    this.accountApiService
      .setPlaceBlockedKeywords(this.account.account.userName, this.blockKeywords)
      .subscribe((data) => {
        this.alertify.successfully('Set blocked keywords places');
        event.complete();
      });
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.place.source/set.place.source.modal.component.ts